import get from 'lodash/fp/get'

import { RootState } from '../../../store/root.reducer'

export const getLoggedUserUsername = (state: RootState) => get('keycloak.tokenParsed.preferred_username', state)
export const getTokenUUID = (state: RootState) => get('keycloak.tokenParsed.uuid', state)
export const getAuthenticated = (state: RootState) => get('keycloak.authenticated', state)
export const getRealm = (state: RootState) => state.keycloak.realm
